
import React, { Component } from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { popupOpenClose, setVideoPlayer } from '../../../action/action'
import { errorMsg } from '../../../config/constant'
//import { movieCardAnimation } from '../../../JS/movieCardAnimation'
import $ from 'jquery'

class MovieCard extends Component {
    componentDidMount() {
        //movieCardAnimation();
    }
    getLanguages = () => {
        let langs = ""
        this.props.languageList.map((iter) => {
            if (this.props.movieInfo) {
                this.props.movieInfo.language.map((iterator) => {
                    if (iterator === iter.id) {
                        langs = langs ? `${langs}/${iter.name}` : iter.name
                    }
                })
            }
        })
        return langs
    }
    getCategories = () => {
        let cate = ""
        this.props.categories.map((iter) => {
            if (this.props.movieInfo) {
                this.props.movieInfo.category.map((iterator) => {
                    if (iterator === iter.id) {
                        cate = cate ? `${cate},${iter.name}` : iter.name
                    }
                })
            }
        })
        return cate
    }
    teaserPlay = () => {
        this.props.setVideoPlayer(true, this.props.movieInfo.teasers[0].teaserUrl);
    }
    playMovieOnTV = () => {
        if (this.props.guestInRoom) {
        } else {
            this.props.popupOpenClose(true, errorMsg);
        }
    }

    render() {
        return (
            <div style={!this.props.movieInfo ? { display: "none" } : null} id={this.props.id} className={this.props.classes}>
                {/* {this.addExtraParams()} */}
                <h4 style={{ color: "inherit" }}> {this.props.movieInfo ? this.props.movieInfo.videoTitle : null}
                    <div className="movie-controls">
                        {this.props.movieInfo && this.props.movieInfo.teasers &&
                            this.props.movieInfo.teasers.length > 0 ?
                            <span
                                className="preview-movie"
                                style={
                                    this.props.menuColor && this.props.menuColor.assetFontSelectorColor ?
                                        { color: "inherit" } : null
                                }
                                onClick={this.teaserPlay}>
                                Preview Movie
                    <i className="fa fa-play" style={{ color: "inherit" }}></i>
                            </span> : null
                        }
                        <span
                            className="play-movie"
                            style={
                                this.props.menuColor && this.props.menuColor.assetFontSelectorColor ?
                                    { color: "inherit" } : null
                            }
                            onClick={this.playMovieOnTV}>
                            {this.props.movieInfo && this.props.movieInfo.videoPrice && this.props.movieInfo.videoPrice !== "0" ?
                                `Buy ${this.props.movieInfo ? this.props.movieInfo.videoPrice : null} $` : "Play Movie"}
                            <i className="fa fa-play" style={{ color: "inherit" }}></i>
                        </span>
                    </div>
                </h4>
                <div style={{ color: "inherit" }} className="movie-info-container">
                    <div
                        className="movie-cover"
                        style={
                            {
                                background: `url('${this.props.movieInfo ? this.props.movieInfo.promoImageUrl : null}') center center no-repeat`,
                                backgroundSize: "cover"
                            }
                        }>
                    </div>
                    <div className="movie-details" style={{ color: "inherit" }}>
                        <p className="keywords" style={{ color: "inherit" }}>
                            <span className="year" style={{ color: "inherit" }}>{this.props.movieInfo ? this.props.movieInfo.releaseYear : null}</span>
                            <span className="rating" style={{ color: "inherit" }}>
                                <i className="fa fa-star" style={{ color: "inherit" }}></i>
                                <i className="fa fa-star" style={{ color: "inherit" }}></i>
                                <i className="fa fa-star" style={{ color: "inherit" }}></i>
                                <i className="fa fa-star" style={{ color: "inherit" }}></i>
                                <i className="fa fa-star-o" style={{ color: "inherit" }}></i>
                            </span>
                            <span className="lang" style={{ color: "inherit" }}>
                                {this.getLanguages()}
                            </span>
                            <span className="genre" style={{ color: "inherit" }}>
                                {this.getCategories()}
                            </span>
                        </p>
                        <p style={{ color: "inherit" }}>
                            {this.props.movieInfo ? this.props.movieInfo.description : null}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        // //movieInfo: state.store.vod.currentMovie,
        // languageList: state.store.vod.VODData ?
        //     state.store.vod.VODData.channelLanguageOrder : null,
        // categories: state.store.vod.VODData ?
        //     state.store.vod.VODData.channelCategoryOrder : null,
        // guestInRoom: state.store.guestInRoom
        menuColor: state.store.home.MenuColor
    }
}

MovieCard.propTypes = {
    guestInRoom: propTypes.bool,
    categories: propTypes.array,
    movieInfo: propTypes.object,
    languageList: propTypes.array
}

MovieCard.defaultProps = {
    guestInRoom: false,
    categories: [],
    movieInfo: {},
    languageList: []
}
export default connect(
    mapStateToProps,
    {
        //  setCurrentMovie,
        setVideoPlayer,
        popupOpenClose
    }
)(MovieCard);
